import { BulkActionConfirmationModal } from "../BulkActionConfirmationModal";

type RemoveFromBillingGroupModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => Promise<void>;
  selectedEntityCount: number;
  billingGroupName: string;
};

export const RemoveFromBillingGroupModal = ({
  billingGroupName,
  ...props
}: RemoveFromBillingGroupModalProps) => (
  <BulkActionConfirmationModal
    {...props}
    title="Remove from billing group"
    confirmationText={`The selected ${props.selectedEntityCount === 1 ? "entity" : "entities"} will be unassigned from the billing group "${billingGroupName}".`}
    testId="remove-from-billing-group-modal"
  />
);
